/**
 * HoursCard
 *
 * Displays a titled card with a list of day → time rows.
 *
 * Props:
 *   title   – string shown in the red header (e.g. "Store Hours")
 *   icon    – emoji shown beside the title
 *   rows    – array of { day: string, time: string }
 *   note    – optional footer note string
 */
export default function HoursCard({ title, icon, rows, note }) {
  return (
    <div className="hours-card">
      <div className="hours-card-hdr">
        <span style={{ fontSize: "1.3rem" }}>{icon}</span>
        <h3>{title}</h3>
      </div>
      <div className="hours-card-body">
        {rows.map(({ day, time }) => (
          <div key={day} className="hours-row">
            <span className="hours-day">{day}</span>
            <span className="hours-time">{time}</span>
          </div>
        ))}
      </div>
      {note && <div className="hours-note">{note}</div>}
    </div>
  );
}
